/*
 * Hook: useGridColumns
 *
 * Given an HTML ref, calculate the number of columns. Recalculates when activeKey changes or the element resizes
 *
 */
import { useLayoutEffect, useRef, useState } from 'react'

type Props = {
  activeKey?: unknown
  enabled: boolean
}

export const useGridColumns = <T extends HTMLElement = HTMLElement>({ activeKey, enabled }: Props) => {
  const ref = useRef<T>(null)
  const [columns, setColumns] = useState(0)

  useLayoutEffect(() => {
    if (!enabled) return
    const el = ref.current
    if (!el) return

    const measure = () => {
      const gridColumns = window.getComputedStyle(el).gridTemplateColumns.split(' ')

      setColumns(gridColumns.filter((col) => col.endsWith('px')).length)
    }

    measure()

    const observer = new ResizeObserver(measure)
    observer.observe(el)

    return () => {
      observer.disconnect()
    }
  }, [activeKey, enabled])

  return { columns, ref }
}
